import { render, staticRenderFns } from "./VisionComponent.vue?vue&type=template&id=5054f530"
import script from "./VisionComponent.vue?vue&type=script&lang=js"
export * from "./VisionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports